export enum FirebaseFunctionNames {
  ADD_USER = 'addUser',
  UPDATE_USER_PASSWORD = 'updateUserPassword',
  RECALCULATE_ROUTE = 'recalculateRoute',
  AGGREGATE_DATA = 'aggregateData',
  EXPORT_DELIVERIES = 'exportDeliveries',
  EXPORT_SUCCESSFUL_DELIVERIES = 'exportSuccessfulDeliveriesPdf',
  EXPORT_SUB_LOCATIONS = 'exportSubLocations',
  EXPORT_LOCATIONS = 'exportLocations',
  EXPORT_ALERTS = 'exportAlerts',
  EXPORT_RUNS = 'exportRuns',
  EXPORT_VEHICLES = 'exportVehicles',
  EXPORT_VEHICLE_CHECKS = 'exportVehicleChecks',
  EXPORT_RUN_ACTIVITY = 'exportRunActivity',
  FORCE_CALCULATE_TOMORROWS_RUN_ACTIVITY = 'forceCalculateTomorrowsRunActivity',
  FORCE_CALCULATE_RUN_ACTIVITY_FOR_DATE = 'forceCalculateRunActivityForDate',
  RESET_USER_PASSWORD = 'resetUserPassword',
  EXPORT_TRANSPORT_JOBS = 'exportTransportJobs',
  SEED_DELIVERY_REQUESTS = 'devSeedDeliveryRequests',
  CLEAR_DELIVERY_REQUESTS = 'devClearDeliveryRequests',
  DEV_JOTFORM_RELAY = 'devJotformRelay',
  DEV_MAIL_ALLOWLIST = 'devMailAllowlist',
  GET_DELIVERY_REQUEST_ROUTING = 'getDeliveryRequestRouting',
  SAVE_DELIVERY_REQUEST_TYPE = 'saveDeliveryRequestType',
  DELETE_DELIVERY_REQUEST_TYPE = 'deleteDeliveryRequestType',
  SEED_DELIVERY_REQUEST_TYPES = 'seedDeliveryRequestTypes',
  SAVE_DELIVERY_REQUEST_SETTINGS = 'saveDeliveryRequestSettings',
  SAVE_DELIVERY_REQUEST_PARTNER = 'saveDeliveryRequestPartner',
  DELETE_DELIVERY_REQUEST_PARTNER = 'deleteDeliveryRequestPartner',
  PREVIEW_TRANSPORT_GROUP = 'previewTransportGroup',
  GET_TRANSPORT_RUN_DRIVERS = 'getTransportRunDrivers',
  ASSIGN_TRANSPORT_GROUP = 'assignTransportGroup',
  POST_TRANSPORT_GROUP = 'postTransportGroup',
  CANCEL_TRANSPORT_GROUP = 'cancelTransportGroup',
  COMMIT_DELIVERY_REQUEST_DECISIONS = 'commitDeliveryRequestDecisions',
  MARK_DELIVERY_REQUEST = 'markDeliveryRequest',
  CORRECT_DELIVERY_REQUEST_ADDRESS = 'correctDeliveryRequestAddress',
  CLEAR_DELIVERY_REQUEST_MARK = 'clearDeliveryRequestMark',
  GET_DELIVERY_REQUEST_REPORT = 'getDeliveryRequestReport',
  EXPORT_DELIVERY_REQUEST_REPORT = 'exportDeliveryRequestReport',
}
